export default "__VITE_ASSET__BxO4NJHG__"